import { FunctionComponent, PropsWithChildren, createContext, useCallback, useMemo } from 'react';

import { noopFunction } from '@vestico/utils';

const VIDEO_SETTINGS_KEY = 'co.vestico.settings.video';

export interface VideoPlaybackSettings {
  volumeOn: boolean;
}
export interface VideoPlaybackContextProps {
  settings: VideoPlaybackSettings;
  onUpdate: (volumeOn: boolean) => void;
}

export const VideoPlaybackContext = createContext<VideoPlaybackContextProps>({ settings: { volumeOn: false }, onUpdate: noopFunction });

export const VideoPlaybackContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const videoSettings = useMemo(() => {
    if (typeof window !== 'undefined') {
      const loadedSettings = localStorage.getItem(VIDEO_SETTINGS_KEY);
      if (loadedSettings) {
        return JSON.parse(loadedSettings) as VideoPlaybackSettings;
      }
    }

    const props: VideoPlaybackSettings = {
      volumeOn: false,
    };
    return props;
  }, []);

  const onUpdate = useCallback(
    (volumeOn: boolean) => {
      videoSettings.volumeOn = volumeOn;
      localStorage.setItem(VIDEO_SETTINGS_KEY, JSON.stringify(videoSettings));
    },
    [videoSettings]
  );

  const contextProps = useMemo(() => {
    return { settings: videoSettings, onUpdate };
  }, [onUpdate, videoSettings]);

  return <VideoPlaybackContext.Provider value={contextProps}>{children}</VideoPlaybackContext.Provider>;
};
